import type { IRegisteredContractLine } from './IRegisteredContractLine';

export class RegisteredContractLine implements IRegisteredContractLine {
    public static parseObject(
        obj: IRegisteredContractLine,
        kontraktId?: string,
    ): RegisteredContractLine {
        try {
            return new RegisteredContractLine(obj, kontraktId);
        } catch (error) {
            throw new Error(
                `Could not parse Contract Registration object : ${JSON.stringify(
                    obj,
                )}`,
            );
        }
    }

    public static empty() {
        return RegisteredContractLine.parseObject(
            {
                gyldigFra: new Date(),
                gyldigTil: new Date(),
                navn: '',
                antall: 0,
                areal: 0,
                arealType: '',
                arealTypeNavn: '',
                arealUntattBeregning: 0,
                id: '',
                aarligBelop: 0,
                kontraktId: '',
                arealUnntattBeregning: false,
                linjeNavn: '',
                linjeType: 0,
                maanedligBelop: 0,
            },
            '',
        );
    }

    public static parseArray(
        kontraktId: string,
        linjer: Array<IRegisteredContractLine>,
    ): Array<IRegisteredContractLine> {
        const result: Array<IRegisteredContractLine> = [];
        linjer.map((item) => {
            result.push(RegisteredContractLine.parseObject(item, kontraktId));
        });
        return result;
    }

    gyldigFra: IRegisteredContractLine['gyldigFra'];
    gyldigTil: IRegisteredContractLine['gyldigTil'];
    navn: IRegisteredContractLine['navn'];
    antall: IRegisteredContractLine['antall'];
    areal: IRegisteredContractLine['areal'];
    arealType: IRegisteredContractLine['arealType'];
    arealTypeNavn: IRegisteredContractLine['arealTypeNavn'];
    arealUntattBeregning: IRegisteredContractLine['arealUntattBeregning'];
    id: IRegisteredContractLine['id'];
    aarligBelop: IRegisteredContractLine['aarligBelop'];
    kontraktId?: string;
    arealUnntattBeregning: IRegisteredContractLine['arealUnntattBeregning'];
    linjeNavn: IRegisteredContractLine['linjeNavn'];
    linjeType: IRegisteredContractLine['linjeType'];
    maanedligBelop: IRegisteredContractLine['maanedligBelop'];

    constructor(props: IRegisteredContractLine, kontraktId?: string) {
        Object.assign(this, props);
        this.gyldigFra = props.gyldigFra;
        this.gyldigTil = props.gyldigTil;
        this.antall = props.antall;
        this.arealType = props.arealType;
        this.arealTypeNavn = props.arealTypeNavn;
        this.arealUntattBeregning = props.arealUntattBeregning;
        this.id = props.id;
        this.aarligBelop = props.aarligBelop;
        this.kontraktId = kontraktId || '';
        this.arealUnntattBeregning = props.arealUnntattBeregning;
        this.linjeNavn = props.linjeNavn;
        this.linjeType = props.linjeType;
        this.maanedligBelop = props.maanedligBelop;
        this.areal = props.areal;
        this.navn = props.navn;
    }

    public get arealAntall(): number {
        return this.areal > 0 ? this.areal : this.antall > 0 ? this.antall : 0;
    }
}
